import { render, staticRenderFns } from "./createAssetBrand.vue?vue&type=template&id=2a95c15c&scoped=true"
import script from "./createAssetBrand.vue?vue&type=script&lang=js"
export * from "./createAssetBrand.vue?vue&type=script&lang=js"
import style0 from "./createAssetBrand.vue?vue&type=style&index=0&id=2a95c15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a95c15c",
  null
  
)

export default component.exports